import React, { useContext } from 'react'

import { VegaEditorContext } from '../../../VegaEditorContext'
import {
  ColorConfig,
  SizeConfig,
  InteractiveFilter,
  NumericAxisConfig,
  TooltipConfig,
  useValidateFields
} from './components'
import { getDataId } from './configUtils'

export const defaultScatter = {
  x: {
    domain: {
      show: true
    },
    grid: {
      show: true
    },
    ticks: {
      show: true
    }
  },
  y: {
    domain: {
      show: true
    },
    grid: {
      show: true
    },
    ticks: {
      show: true
    }
  },
  symbol: {
    size: 8
  }
}

// Assign labels for each of the items we can configure with color.
const colorTypes = [
  {
    val: 'mark',
    label: 'Dots'
  },
  {
    val: 'hover',
    label: 'Hover'
  }
]

const fieldProps = ['x', 'y', 'color', 'size', 'tt', 'iflt']

export const ScatterConfig = () => {
  const { config } = useContext( VegaEditorContext )

  const curDataId = getDataId( config, fieldProps )

  // console.log( 'SCATTER CONFIG:', config )

  // Remove any fields that aren't valid based on referencing an invalid
  // dataset.
  useValidateFields( fieldProps )

  return (
    <div  className="cp-ctls" >

      <NumericAxisConfig
        prop="x"
        label="X Axis"
        defaultProps={defaultScatter}
        validDataset={curDataId}
      />

      <NumericAxisConfig
        prop="y"
        label="Y Axis"
        defaultProps={defaultScatter}
        validDataset={curDataId}
      />

      <ColorConfig
        isDynamic
        validDataset={curDataId}
        staticTypes={colorTypes}
      />

      <SizeConfig
        isDynamic
        validDataset={curDataId}
      />

      <TooltipConfig prop="tt" />

      <InteractiveFilter prop="iflt" />
    </div>
  )
}
//
// ScatterConfig.propTypes = {
//   dataSets: PropTypes.object.isRequired,
//   config: PropTypes.object.isRequired,
//   onUpdate: PropTypes.func.isRequired
// }
